<template>
  <div>
    <el-table ref="multipleTable"
              :data="dataList"
              tooltip-effect="dark"
              height="100%" style="width: 100%"
              @row-click="clickFn"
              @row-dblclick="dblclickFn"
              @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="序号" align="center" prop="index" width="50"></el-table-column>
      <el-table-column label="字典编号" align="center" prop="dicCode"></el-table-column>
      <el-table-column label="字典名称" align="center" prop="dicName"></el-table-column>
      <el-table-column label="字典值" align="center" prop="dicValue"></el-table-column>
      <el-table-column label="类型" align="center" prop="dicType"></el-table-column>
      <el-table-column label="状态" align="center" prop="state">
        <template slot-scope="scope">
          <el-tag :type="oStateType[scope.row.state]">{{oState[scope.row.state]}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="说明" align="center" prop="dicExplain"></el-table-column>
      <el-table-column label="备注" align="center" prop="remark1"></el-table-column>
    </el-table>
  </div>
</template>
<script>
const oState = {
  1: '有效',
  0: '失效'
};
const oStateType = {
  1: 'success',
  0: 'danger'
};
export default {
  name: 'list',
  props: {
    dataList: {
      Array,
      default: []
    }
  },
  data() {
    return {
      oState,
      oStateType
    };
  },
  methods: {
    handleSelectionChange(selectArrys) {
      for (let i = 0; i < this.dataList.length; i++) {
        let item = this.dataList[i];
        item.checked = false;
      }
      for (let i = 0; i < selectArrys.length; i++) {
        selectArrys[i].checked = true;
      }
    },
    clickFn(row) {
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    dblclickFn(row) {
      this.$refs.multipleTable.clearSelection();
      this.$refs.multipleTable.toggleRowSelection(row);
      this.$emit('detail');
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
